export const getUsersForNewChcrmFrag = `
    id
    name
    surname
    email
    sex
    organizations {
        id
    }
`;
